import React from "react";
import PropTypes from 'prop-types';
import { getThumbnail } from "Data/media/MediaSelectors";

export default class Image extends React.Component
{
    static propTypes = {
        media: PropTypes.object.isRequired,
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
        properties: PropTypes.object.isRequired,
    };

    render()
    {
        const { media, width, height } = this.props;

        const thumbnail = getThumbnail(this.props.media, 400, 600);

        const src = thumbnail ? thumbnail.url : media.filename;

        const style = {
            width: width,
            height: height,
            backgroundImage: `url('${src}')`
        };

        if ('borderRadius' in this.props.properties) {
            style.borderRadius = parseInt(this.props.properties.borderRadius);
        }

        return <div className="bg-cover bg-center" style={style} />;
    }
}
